import styled from 'styled-components';
import { colors } from 'core/theme';

export const InputWrapper = styled.div`
  position: relative;

  @media print {
    display: inline-block;

    & > input {
      border: 0;
      color: ${colors.black};
      margin-left: 0.5em;
      min-height: 0;
      padding: 0;
      width: auto;

      &[value=""] {
        display: none;
      }
    }

    & > div {
      display: none;
    }
  }
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  height: 100%;

  & > button {
    height: 100%;
    padding: 0 0.5em;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/KeywordsInput/styled.js